/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { AaiOAuthFlows } from '../../models/AaiOAuthFlows';
import { Node } from '../../../core/models/Node';
import { AuthorizationCodeOAuthFlow } from '../../../core/models/common/AuthorizationCodeOAuthFlow';
import { ClientCredentialsOAuthFlow } from '../../../core/models/common/ClientCredentialsOAuthFlow';
import { ImplicitOAuthFlow } from '../../../core/models/common/ImplicitOAuthFlow';
import { PasswordOAuthFlow } from '../../../core/models/common/PasswordOAuthFlow';

/**
 * @author Jakub Senko<jsenko@redhat.com>
 * @param {Node} parent
 * @class
 * @extends AaiOAuthFlows
 */
export class Aai20OAuthFlows extends AaiOAuthFlows {
    public constructor(parent? : any) {
        if(((parent != null && parent instanceof <any>Node) || parent === null)) {
            let __args = arguments;
            super(parent);
        } else if(parent === undefined) {
            let __args = arguments;
            super();
        } else throw new Error('invalid overload');
    }

    /**
     * 
     * @return {ImplicitOAuthFlow}
     */
    public createImplicitOAuthFlow() : ImplicitOAuthFlow {
        return new Aai20ImplicitOAuthFlow(this);
    }

    /**
     * 
     * @return {PasswordOAuthFlow}
     */
    public createPasswordOAuthFlow() : PasswordOAuthFlow {
        return new Aai20PasswordOAuthFlow(this);
    }

    /**
     * 
     * @return {ClientCredentialsOAuthFlow}
     */
    public createClientCredentialsOAuthFlow() : ClientCredentialsOAuthFlow {
        return new Aai20ClientCredentialsOAuthFlow(this);
    }

    /**
     * 
     * @return {AuthorizationCodeOAuthFlow}
     */
    public createAuthorizationCodeOAuthFlow() : AuthorizationCodeOAuthFlow {
        return new Aai20AuthorizationCodeOAuthFlow(this);
    }
}
Aai20OAuthFlows["__class"] = "io.apicurio.datamodels.asyncapi.v2.models.Aai20OAuthFlows";
Aai20OAuthFlows["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];





import { Aai20AuthorizationCodeOAuthFlow } from './Aai20AuthorizationCodeOAuthFlow';


import { Aai20ClientCredentialsOAuthFlow } from './Aai20ClientCredentialsOAuthFlow';


import { Aai20PasswordOAuthFlow } from './Aai20PasswordOAuthFlow';


import { Aai20ImplicitOAuthFlow } from './Aai20ImplicitOAuthFlow';

